__turbopack_context__.v({
  "sliceZoneLoading": "HomePage-module-scss-module__aMBJGq__sliceZoneLoading",
});
